import { DOWN_AND_DISTANCE, FIELD_ZONE } from '../../constants/filters';

export const DOWN_AND_DISTANCE_KEY = 'dd';
export const FIELD_ZONE_KEY = 'fz';


export function getFilters(type, filters) {
  if (type === DOWN_AND_DISTANCE_KEY) return filters[DOWN_AND_DISTANCE] || [];
  return filters[FIELD_ZONE] || [];
}
